import { render, staticRenderFns } from "./sell-card.vue?vue&type=template&id=01ab093e&scoped=true&"
import script from "./sell-card.vue?vue&type=script&lang=js&"
export * from "./sell-card.vue?vue&type=script&lang=js&"
import style0 from "./sell-card.vue?vue&type=style&index=0&id=01ab093e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab093e",
  null
  
)

export default component.exports